
import { defineComponent, PropType, ref, watch, nextTick } from 'vue'

import { Game } from '@/types/game'
import { GameEvent } from '@/types/gameEvent'
import { RosterPlayer } from '@/types/rosterPlayer'

import _ from 'lodash.clonedeep'

export default defineComponent({
  inheritAttrs: false,
  props: {
    teamType: {
      type: String,
      required: true
    },
    game: {
      type: Object as PropType<Game>
    },
    events: {
      type: Array as PropType<GameEvent[]>
    },
    rosters: {
      type: Array as PropType<RosterPlayer[]>
    }
  },
  setup(props, context) {
    const eventTable = ref<HTMLElement>()

    watch(
      () => _(props.events),
      (events, prevEvents) => {
        if (events == undefined || prevEvents == undefined) return
        if (events.length > prevEvents.length) scrollBottom()
      },
      { immediate: false, deep: true }
    )

    const scrollBottom = () => {
      nextTick(() => {
        let eventTableElem = eventTable.value as HTMLElement
        const tableHeight = eventTableElem.scrollHeight as number

        eventTableElem.scrollTo({
          top: tableHeight,
          left: 0,
          behavior: 'smooth'
        })
      })
    }

    const onClickEventButton = (event_id: number, teamType: string) => {
      context.emit('onClickEventButton', event_id, teamType)
    }

    const onChangeEvent = (event: GameEvent) => {
      context.emit('onChangeEvent', event)
    }

    const onClickDeleteButton = (event: GameEvent) => {
      context.emit('onClickDeleteButton', event)
    }

    return {
      eventTable,

      onClickEventButton,
      onChangeEvent,
      onClickDeleteButton
    }
  }
})
